<div class="content" [attr.aria-busy]="isLoading ? 'true' : 'false'">
  <ng-content></ng-content>
</div>

@if (isLoading) {
  <div class="overlay" aria-live="assertive">
    <div class="spinner-overlay">
      <mat-spinner
        [mode]="'indeterminate'"
        [diameter]="spinnerSize"
        [attr.aria-label]="'Page is loading content.'"
      ></mat-spinner>
      @if (!!this.screenReaderText) {
        <app-dynamic-confirmation [wrapperClass]="'sr-only'">
          {{ this.screenReaderText || 'Page is loading content.' }}
        </app-dynamic-confirmation>
      }
    </div>
  </div>
}
